// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","bg":"Modal_bg__Qa9ah","content":"Modal_content__yBmFf","successModalClose":"Modal_successModalClose__q3f+Y","closeIcon":"Modal_closeIcon__PA6+Y"};